import { AgGridModule } from '@ag-grid-community/angular';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  NgbCollapseModule,
  NgbDropdownModule,
  NgbPaginationModule,
  NgbTypeaheadModule,
} from '@ng-bootstrap/ng-bootstrap';
import { LetDirective, PushPipe } from '@ngrx/component';
import { MomentModule } from 'ngx-moment';
import { NgxPermissionsModule } from 'ngx-permissions';
import { ToastrModule } from 'ngx-toastr';
import {
  BreadcrumbItemDirective,
  BreadcrumbComponent as XngBreadcrumbComponent,
} from 'xng-breadcrumb';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { UiKitCoreModule } from './core/uikit-core.module';
import { DocumentTypeReaderComponent } from './document-type-reader/document-type-reader.component';
import { EntityListComponent } from './entity-list/entity-list.component';
import { ErrorPageComponent } from './error-page/error-page.component';
import { FeatherIconDirective } from './feather-icon/feather-icon.directive';
import { FiltersFormComponent } from './filters/filters-form/filters-form.component';
import { OperatorFilterComponent } from './filters/operators/operators.component';
import { SingleFilterComponent } from './filters/single-filter/single-filter.component';
import { FormFieldsModule } from './form-fields/form-fields.module';
import { CustomGridFilterComponent } from './grid/custom-grid-filter.component';
import { DataGridActionRenderer } from './grid/data-grid/data-grid-action-renderer.component';
import { DataGridComponent } from './grid/data-grid/data-grid.component';
import { HistoryDataGridComponent } from './grid/history-data-grid/history-data-grid.component';
import { LoaderComponent } from './loader/loader.component';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { ToastComponent } from './toast/toast.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AgGridModule,
    NgbPaginationModule,
    NgbTypeaheadModule,
    LetDirective,
    PushPipe,
    SafeHtmlPipe,
    NgxPermissionsModule.forChild(),
    UiKitCoreModule,
    NgbDropdownModule,
    FormFieldsModule,
    XngBreadcrumbComponent,
    BreadcrumbItemDirective,
    NgbCollapseModule,
    ToastrModule.forRoot({
      positionClass: 'toast-top-right',
      tapToDismiss: true,
      // iconClasses: {
      //   error: 'toast-error',
      //   info: 'toast-info',
      //   success: 'toast-success',
      //   warning: 'toast-warning',
      // },
    }),
    MomentModule,
  ],
  declarations: [
    FiltersFormComponent,
    SingleFilterComponent,
    OperatorFilterComponent,
    EntityListComponent,
    FeatherIconDirective,
    CustomGridFilterComponent,
    DataGridActionRenderer,
    BreadcrumbComponent,
    LoaderComponent,
    ToastComponent,
    ErrorPageComponent,
    DataGridComponent,
    HistoryDataGridComponent,
    DocumentTypeReaderComponent,
  ],
  exports: [
    SafeHtmlPipe,
    ErrorPageComponent,
    FiltersFormComponent,
    EntityListComponent,
    FeatherIconDirective,
    UiKitCoreModule,
    CustomGridFilterComponent,
    FormFieldsModule,
    BreadcrumbComponent,
    LoaderComponent,
    DataGridComponent,
    HistoryDataGridComponent,
    DocumentTypeReaderComponent,
    MomentModule,
    SingleFilterComponent,
  ],
  // schemas: [NO_ERRORS_SCHEMA],
})
export class UiKitModule {}
